import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';

import type { ResponseModel } from 'common/interfaces';
import { QueryHookOptions } from 'hooks/react-query/react-query.props';
import { useFetch } from 'hooks/use-fetch/use-fetch';
import { useTypedSelector } from 'hooks/use-typed-selector';

import { fleetRequestConfig } from 'request-config/fleet/fleet.request-config';

import { UnusedFleetQueryKeys } from '../fleet.props';
import { UnusedFleetResponseItem } from './unused-fleet.props';

type UnusedFleetResponse = AxiosResponse<
  ResponseModel<{
    fuhrparks: Array<{
      id: string;
      attributes: UnusedFleetResponseItem;
      name: string;
    }>;
    leasingVertrages: unknown[];
  }>
>;

export const useUnusedFleetQuery = (
  userIdProps?: string,
  { options }: QueryHookOptions<UnusedFleetResponse, UnusedFleetResponse> = {}
) => {
  const user = useTypedSelector(state => state.app.user);
  const userId = userIdProps || user.id;

  const { fetch } = useFetch<UnusedFleetResponse>({
    loadingKey: `unusedFleetQuery${userId}`,
    ...fleetRequestConfig.unusedFleet(userId)
  });

  const { data, ...restQueryProps } = useQuery({
    queryKey: [UnusedFleetQueryKeys.UnusedFleet, userId],
    queryFn: () => fetch(),
    ...options
  });

  return { unusedFleetQuery: data?.data.data.fuhrparks ?? [], ...restQueryProps };
};
